import React from "react";
import classes from "./Breadcrumbs.module.scss";

interface Props {
  icon?: React.ReactNode;
  children: React.ReactNode;
  onEditClick: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

function Breadcrumb({ icon, children, onEditClick }: Props) {
  const onClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    return onEditClick(event);
  };

  return (
    <div className={`d-flex align-items-center ${classes.breadcrumb}`}>
      {/* {icon && <Image src={icon} className={classes.icon} />} */}
      {icon}
      <span className={classes.label}>{children}</span>
      <a href="#" className={"link transparent"} onClick={onClick}>
        Edit
      </a>
    </div>
  );
}

export default Breadcrumb;
